//@ts-nocheck
import * as actions from './productionApiActions';
export const validateSSN = actions.validateSSN;
export const applyAfterPrequalification = actions.applyAfterPrequalification;
export const createCreditApplicationIdentityVerification = actions.createCreditApplicationIdentityVerification;
export const getCreditApplicationIdentityVerification = actions.getCreditApplicationIdentityVerification;
export const submitFullApplication = actions.submitFullApplication;
